import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-6, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconChart6"><path d="M23 21V20H20.9902V3.00098H15.6602V20H14.6601V8.50098H9.33008V20H8.33V14.001H3V20H1V21L8.33 21.001L9.33008 21H23Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart6;
